import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 56 — GoHighLevel hiring-cost & remote-hiring cluster service links.
 *
 * Every Batch 56 article routes its primary commercial link to
 * /gohighlevel-revops-architect. The answer-first leads in batch56Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /gohighlevel-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH56_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "cost-to-hire-a-gohighlevel-expert": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /\$40-an-hour freelancer with a rework cycle is not a \$600-a-month direct hire you own/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-va-vs-gohighlevel-expert": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /VA who configures a workflow is not an architect who designs the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "hire-a-gohighlevel-va-in-the-philippines": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /candidate who lists GoHighLevel on a profile is not a vetted specialist who can architect the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-retainer-pricing-explained": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /\$250 retainer that skips the builds is not a \$1,500 retainer that ships the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
